import store from '@/store/index'
import Home from '@/views/Home.vue'
import SignIn from '@/views/SignIn.vue'
import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'

Vue.use(VueRouter)

export enum RoutePath {
  home = '/',
  history = '/history',
  signIn = '/sign_in',
  wildcard = '*',
}

export enum RouteName {
  home = 'Home',
  history = 'History',
  signIn = 'SignIn',
  wildcard = 'Wildcard',
}

export const routes: (RouteConfig &
  ({ icon: string; showInDrawer: true } | { showInDrawer: false }))[] = [
  {
    path: RoutePath.home,
    name: RouteName.home,
    component: Home,
    icon: 'mdi-home',
    showInDrawer: true,
  },
  {
    path: RoutePath.history,
    name: RouteName.history,
    component: () => import('@/views/RedemptionHistory.vue'),
    icon: 'mdi-history',
    showInDrawer: true,
  },
  {
    path: RoutePath.signIn,
    name: RouteName.signIn,
    component: SignIn,
    showInDrawer: false,
  },
  {
    path: RoutePath.wildcard,
    name: RouteName.wildcard,
    component: () => import('@/views/UnknownPage.vue'),
    showInDrawer: false,
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

router.beforeEach((to, from, next) => {
  if (to.path === RoutePath.signIn) {
    if (store.state.State.s.user) {
      return next(RoutePath.home)
    }
  } else {
    if (!store.state.State.s.user) {
      return next(RoutePath.signIn)
    }
  }
  next()
})

export default router
